import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useOrigin } from './OriginContext';
import { ORIGIN_TOKENS } from './tokens';

const OriginFilament: React.FC = () => {
  const { state } = useOrigin();
  const MotionDiv = motion.div as any;

  const getFilamentColor = () => {
    switch (state) {
      case 'loading': return ORIGIN_TOKENS.colors.accent;
      case 'success': return ORIGIN_TOKENS.colors.success;
      case 'warning': return ORIGIN_TOKENS.colors.warning;
      case 'error': return ORIGIN_TOKENS.colors.error;
      default: return 'transparent';
    }
  };

  return (
    <div 
      className="origin-filament-container"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: ORIGIN_TOKENS.rhythm.filament,
        zIndex: 9991, 
        pointerEvents: 'none',
        overflow: 'hidden'
      }}
    >
      <AnimatePresence>
        {(state as string) !== 'idle' && (
          <MotionDiv
            initial={{ scaleX: 0, opacity: 0 }}
            animate={{ 
              scaleX: state === 'loading' ? 0.7 : 1, 
              opacity: 1,
              backgroundColor: getFilamentColor()
            }}
            exit={{ opacity: 0 }}
            transition={{
              type: 'spring',
              stiffness: 100,
              damping: 20,
              scaleX: state === 'loading' ? {
                repeat: Infinity,
                repeatType: 'reverse',
                duration: 1.5,
                ease: [0.16, 1, 0.3, 1]
              } : { duration: 0.4, ease: [0.16, 1, 0.3, 1] }
            } as any}
            style={{
              width: '100%',
              height: '100%',
              originX: 0,
              boxShadow: state !== 'idle' ? `0 0 12px ${getFilamentColor()}` : 'none'
            }}
          />
        )}
      </AnimatePresence>
    </div>
  );
};

export default OriginFilament;
